const initialState = {
  conceptos: [],
  company: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CONCEPTOS":
      return { ...state, conceptos: action.payload };
    case "SET_COMPANY":
      return { ...state, company: action.payload };
    case "CLEAR_COMPANY":
      return { ...state, company: "" };
    default:
      return state;
  }
};

export default reducer;